import React, { createContext, useEffect, useMemo, useState } from 'react';

export const CartContext = createContext({
  items: [],
  addItem: () => {},
  removeItem: () => {},
  clear: () => {},
  count: 0,
});

const STORAGE_KEY = 'cg_cart_v1';

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) {
      console.warn('Failed to parse cart from storage', e);
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      console.warn('Failed to persist cart to storage', e);
    }
  }, [items]);

  const addItem = (item, qty = 1) => {
    if (!item || !item.id) return;
    setItems((prev) => {
      const existing = prev.find((p) => p.id === item.id);
      if (existing) {
        return prev.map((p) => (p.id === item.id ? { ...p, qty: p.qty + qty } : p));
      }
      return [...prev, { 
        id: item.id, 
        menu_item_id: item.menu_item_id || item.id, // Store menu_item_id for API calls
        title: item.title, 
        price: item.price, 
        img: item.img || null, 
        qty 
      }];
    });
  };

  const updateItemQty = (id, qty) => {
    if (!id) return;
    setItems((prev) => {
      return prev.map((p) => (p.id === id ? { ...p, qty: Math.max(0, qty) } : p)).filter((p) => p.qty > 0);
    });
  };

  const removeItem = (id) => setItems((prev) => prev.filter((p) => p.id !== id));
  const clear = () => setItems([]);

  const value = useMemo(
    () => ({ items, addItem, updateItemQty, removeItem, clear, count: items.reduce((s, it) => s + (it.qty || 0), 0) }),
    [items]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export default CartProvider;
